import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-yesnoconfirmation-modal',
    templateUrl: './yesnoconfirmation-modal.component.html',
    styleUrls: ['./yesnoconfirmation-modal.component.scss']
})
export class YesNoConfirmationModalComponent {

    public message: string;
    public data: any;

    constructor(private instance: NgbActiveModal) { }

    public Close = function (action) {
        this.instance.close(action);
    }

    public Dismiss = function () {
        this.instance.dismiss();
    }

    public Save = function () {
        this.instance.dismiss();
    }

    public DismissAndRedirectBack() {
        this.instance.dismiss();
        if (this.data.action !== 'close') {
        }
    }
}
